export const UPDATE_NEWS_REQUEST = 'news/UPDATE_NEWS_REQUEST';
export const UPDATE_NEWS_SUCCESS = 'news/UPDATE_NEWS_SUCCESS';
export const UPDATE_NEWS_FAILURE = 'news/UPDATE_NEWS_FAILURE';
export const RESET_UPDATE_NEWS_STATE = 'news/RESET_UPDATE_NEWS_STATE';

export const updateNewsRequest = (id, formData) => ({
    type: UPDATE_NEWS_REQUEST,
    payload: { id, formData },
});

export const updateNewsSuccess = (data) => ({
    type: UPDATE_NEWS_SUCCESS,
    payload: data,
});

export const updateNewsFailure = (error) => ({
    type: UPDATE_NEWS_FAILURE,
    payload: error,
});

export const resetUpdateNewsState = () => ({
    type: RESET_UPDATE_NEWS_STATE
})